import { render } from "./AppHeaderComponent.vue?vue&type=template&id=6a24f523&scoped=true"
import script from "./AppHeaderComponent.vue?vue&type=script&lang=js"
export * from "./AppHeaderComponent.vue?vue&type=script&lang=js"

import "./AppHeaderComponent.vue?vue&type=style&index=0&id=6a24f523&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a24f523"]])

export default __exports__